export default __webpack_public_path__ + "static/media/battery-charging.1aac94c5.svg";